<template>
  <div class="webRTCVideo">
    <video ref="localvideo" autoplay playsinline muted controls></video>
    <!--<Button type="primary" @click="start()" style="float:right;">{{goButtonText}}</Button>-->
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions} from 'vuex'
  import $config from '@/config'

	export default {
    data(){
      return{
        GO_BUTTON_START: "Publish",
        GO_BUTTON_STOP: "Stop",
        goButtonText: null ,
        localVideo:null,
        remoteVideo:null,
        peerConnection:null,
        peerConnectionConfig:{'iceServers': []},
        localStream:null,
        wsURL:"wss://live.cdn22.livecasthq.com/webrtc-session.json",
        wsConnection:null,
        streamInfo: {applicationName:"webrtc", streamName:"myStream", sessionId:"[empty]"},
        userData:{param1:"value1"},
        videoBitrate:1000,
        audioBitrate:64,
        videoFrameRate:"29.97",
        videoChoice:"42e01f",
        audioChoice:"opus",
        videoIndex:-1,
        audioIndex:-1,
        userAgent: navigator.userAgent,
        newAPI:false,
        SDPOutput: new Object(),
        SDPDataTag: null,
        constraints:{
          video: {
            width: {min: 1280, ideal: 1280},
            height: {min: 720, ideal: 720},
      		},
    		  audio: true,
        },
        isReady: false,
      }
    },
    computed:{
      ...mapGetters('webcast', {
        webcast: 'getCopy'
      })
    },
    methods:{
      pageReady(){
        this.localVideo = this.$refs.localvideo;
        this.goButtonText = this.GO_BUTTON_START;
        if(navigator.mediaDevices.getUserMedia){
    		  navigator.mediaDevices.getUserMedia(this.constraints).then(this.getUserMediaSuccess).catch(this.errorHandler);
    		  this.newAPI = true;
    	  } else if (navigator.getUserMedia){
          navigator.getUserMedia(this.constraints, this.getUserMediaSuccess, this.errorHandler);
          this.newAPI = false;
        } else {
          alert('Your browser does not support getUserMedia API');
        }
    	  console.log("newAPI: "+ this.newAPI);
      },
      getUserMediaSuccess(stream){
      	console.log("getUserMediaSuccess: "+stream);
        console.log(stream);
        this.localStream = stream;
      	try {
      		this.localVideo.srcObject = stream;
      	} catch (error){
      		this.localVideo.src = window.URL.createObjectURL(stream);
      	}
      },
      wsConnect(url){
      	this.wsConnection = new WebSocket(url);
      	this.wsConnection.binaryType = 'arraybuffer';

      	this.wsConnection.onopen = () => {
      		console.log("wsConnection.onopen");
      		this.peerConnection = new RTCPeerConnection(this.peerConnectionConfig);
      		this.peerConnection.onicecandidate = this.gotIceCandidate;

          const constraints = {
            width: {min: 1280, ideal: 1280},
            height: {min: 720, ideal: 720},
            advanced: [
              {width: 1920, height: 1280},
              {aspectRatio: 1.333}
            ]
          };
          const track = this.localStream.getVideoTracks()[0];
          track.applyConstraints(constraints)

      		if (this.newAPI){
      			var localTracks = this.localStream.getTracks();
            console.log(this.localStream);
      			_.forEach(localTracks, (localTrack, key)=>{
              console.log(localTrack.width);
              console.log(localTrack.height);
      				this.peerConnection.addTrack(localTrack, this.localStream);
            });
      		} else {
            console.log(this.localStream);
            console.log(this);
      			this.peerConnection.addStream(this.localStream);
      		}



      		this.peerConnection.createOffer(this.gotDescription, this.errorHandler);
      	}

        this.wsConnection.onmessage = (evt) => {
      		console.log("wsConnection.onmessage: "+evt.data);

      		var msgJSON = JSON.parse(evt.data);
      		var msgStatus = Number(msgJSON['status']);
      		var msgCommand = msgJSON['command'];

      		if (msgStatus != 200) {
      			this.SDPDataTag = msgJSON['statusDescription'];
            console.log(msgJSON['statusDescription']);
      			this.stopPublisher();
      		} else {
      			this.SDPDataTag = "";

      			var sdpData = msgJSON['sdp'];
      			if (sdpData !== undefined){
      				console.log('sdp: '+msgJSON['sdp']);
      				this.peerConnection.setRemoteDescription(new RTCSessionDescription(sdpData), ()=>{
      					//peerConnection.createAnswer(gotDescription, errorHandler);
      				}, this.errorHandler);
      			}

      			var iceCandidates = msgJSON['iceCandidates'];
      			if (iceCandidates !== undefined) {
      				for(var index in iceCandidates) {
      					console.log('iceCandidates: '+iceCandidates[index]);
      					this.peerConnection.addIceCandidate(new RTCIceCandidate(iceCandidates[index]));
      				}
      			}
      		}

      		if (this.wsConnection != null){
            this.wsConnection.close();
            this.wsConnection = null;
          }
      	}

        this.wsConnection.onclose = () => {
      		console.log("wsConnection.onclose");
      	}

      	this.wsConnection.onerror = (evt) => {
      		console.log("wsConnection.onerror: "+JSON.stringify(evt));
      		this.SDPDataTag = 'WebSocket connection failed: '+this.wsURL;
      		this.stopPublisher();
      	}
      },
      startPublisher(){
      	console.log("startPublisher: wsURL:"+this.wsURL+" streamInfo:"+JSON.stringify(this.streamInfo));
      	this.wsConnect(this.wsURL);
        this.goButtonText = this.GO_BUTTON_STOP;
      },
      stopPublisher() {
      	if (this.peerConnection != null){
          this.peerConnection.close();
      	  this.peerConnection = null;
        }

      	if (this.wsConnection != null){
          this.wsConnection.close();
          this.wsConnection = null;
        }

      	this.goButtonText = this.GO_BUTTON_START;
      	console.log("stopPublisher");
      },
      start(){
      	if (this.peerConnection == null)
      		this.startPublisher();
      	else
      		this.stopPublisher();
      },
      gotIceCandidate(event){
        if(event.candidate != null){
        	console.log('gotIceCandidate: '+JSON.stringify({'ice': event.candidate}));
        }
      },
      gotDescription(description){
      	var enhanceData = new Object();

      	if (this.audioBitrate !== undefined)
      		enhanceData.audioBitrate = Number(this.audioBitrate);
      	if (this.videoBitrate !== undefined)
      		enhanceData.videoBitrate = Number(this.videoBitrate);
      	if (this.videoFrameRate !== undefined)
      		enhanceData.videoFrameRate = Number(this.videoFrameRate);


      	description.sdp = this.enhanceSDP(description.sdp, enhanceData);

      	console.log('gotDescription: '+JSON.stringify({'sdp': description}));

        this.peerConnection.setLocalDescription(description, ()=>{
          console.log("wsConnection send");
          console.log(this.streamInfo);
      	  this.wsConnection.send('{"direction":"publish","command":"sendOffer","streamInfo":{"applicationName":"webrtc", "streamName":"myStream", "sessionId":"[11223]"}, "sdp":'+JSON.stringify(description)+',"userData":'+JSON.stringify(this.userData)+'}');
        }, function() {console.log('set description error')});
      },

      addAudio(sdpStr, audioLine){
      	var sdpLines = sdpStr.split(/\r\n/);
      	var sdpSection = 'header';
      	var hitMID = false;
      	var sdpStrRet = '';
      	var done = false;

      	for(var sdpIndex in sdpLines){
      		var sdpLine = sdpLines[sdpIndex];
      		if (sdpLine.length <= 0)
      			continue;

      		sdpStrRet +=sdpLine;
      		sdpStrRet += '\r\n';

      		if ( 'a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == false ){
      			sdpStrRet +=audioLine;
      			done = true;
      		}
      	}
      	return sdpStrRet;
      },
      addVideo(sdpStr, videoLine){
      	var sdpLines = sdpStr.split(/\r\n/);
      	var sdpSection = 'header';
      	var hitMID = false;
      	var sdpStrRet = '';
      	var done = false;

      	var rtcpSize = false;
      	var rtcpMux = false;

      	for(var sdpIndex in sdpLines){
      		var sdpLine = sdpLines[sdpIndex];

      		if (sdpLine.length <= 0)
      			continue;

      		if ( sdpLine.includes("a=rtcp-rsize") ){
      			rtcpSize = true;
      		}

      		if ( sdpLine.includes("a=rtcp-mux") ){
      			rtcpMux = true;
      		}
      	}

      	for(var sdpIndex in sdpLines){
      		var sdpLine = sdpLines[sdpIndex];

      		sdpStrRet +=sdpLine;
      		sdpStrRet += '\r\n';

      		if ( ('a=rtcp-rsize'.localeCompare(sdpLine) == 0 ) && done == false && rtcpSize == true){
      			sdpStrRet +=videoLine;
      			done = true;
      		}

      		if ( 'a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == true && rtcpSize == false){
      			sdpStrRet +=videoLine;
      			done = true;
      		}

      		if ( 'a=rtcp-mux'.localeCompare(sdpLine) == 0 && done == false && rtcpSize == false ){
      			done = true;
      		}
      	}
      	return sdpStrRet;
      },
      enhanceSDP(sdpStr, enhanceData)
      {
      	var sdpLines = sdpStr.split(/\r\n/);
      	var sdpSection = 'header';
      	var hitMID = false;
      	var sdpStrRet = '';

      	//console.log("Original SDP: "+sdpStr);

      	// Firefox provides a reasonable SDP, Chrome is just odd
      	// so we have to doing a little mundging to make it all work
      	if ( !sdpStr.includes("THIS_IS_SDPARTA") || this.videoChoice.includes("VP9") ){
      		for(var sdpIndex in sdpLines){
      			var sdpLine = sdpLines[sdpIndex];

      			if (sdpLine.length <= 0)
      				continue;

      			var doneCheck = this.checkLine(sdpLine);
      			if ( !doneCheck )
      				continue;

      			sdpStrRet +=sdpLine;
      			sdpStrRet += '\r\n';
      		}
      		sdpStrRet =  this.addAudio(sdpStrRet, this.deliverCheckLine(this.audioChoice,"audio"));
      		sdpStrRet =  this.addVideo(sdpStrRet, this.deliverCheckLine(this.videoChoice,"video"));
      		sdpStr = sdpStrRet;
      		sdpLines = sdpStr.split(/\r\n/);
      		sdpStrRet = '';
      	}

      	for(var sdpIndex in sdpLines){
      		var sdpLine = sdpLines[sdpIndex];

      		if (sdpLine.length <= 0)
      			continue;

      		if ( sdpLine.indexOf("m=audio") ==0 && this.audioIndex !=-1 ){
      			var audioMLines = sdpLine.split(" ");
      			sdpStrRet+=audioMLines[0]+" "+audioMLines[1]+" "+audioMLines[2]+" "+this.audioIndex+"\r\n";
      			continue;
      		}

      		if ( sdpLine.indexOf("m=video") == 0 && this.videoIndex !=-1 ){
      			var audioMLines = sdpLine.split(" ");
      			sdpStrRet+=audioMLines[0]+" "+audioMLines[1]+" "+audioMLines[2]+" "+this.videoIndex+"\r\n";
      			continue;
      		}

      		sdpStrRet += sdpLine;

      		if (sdpLine.indexOf("m=audio") === 0){
      			sdpSection = 'audio';
      			hitMID = false;
      		} else if (sdpLine.indexOf("m=video") === 0) {
      			sdpSection = 'video';
      			hitMID = false;
      		} else if (sdpLine.indexOf("a=rtpmap") == 0 ) {
      			sdpSection = 'bandwidth';
      			hitMID = false;
      		}

      		if (sdpLine.indexOf("a=mid:") === 0 || sdpLine.indexOf("a=rtpmap") == 0 ) {
      			if (!hitMID) {
      				if ('audio'.localeCompare(sdpSection) == 0) {
      					if (enhanceData.audioBitrate !== undefined) {
      						sdpStrRet += '\r\nb=CT:' + (enhanceData.audioBitrate);
      						sdpStrRet += '\r\nb=AS:' + (enhanceData.audioBitrate);
      					}
      					hitMID = true;
      				} else if ('video'.localeCompare(sdpSection) == 0) {
      					if (enhanceData.videoBitrate !== undefined) {
      						sdpStrRet += '\r\nb=CT:' + (enhanceData.videoBitrate);
      						sdpStrRet += '\r\nb=AS:' + (enhanceData.videoBitrate);
      						if ( enhanceData.videoFrameRate !== undefined ) {
      							sdpStrRet += '\r\na=framerate:'+enhanceData.videoFrameRate;
      						}
      					}
      					hitMID = true;
      				} else if ('bandwidth'.localeCompare(sdpSection) == 0 ) {
      					var rtpmapID;
      					rtpmapID = this.getrtpMapID(sdpLine);
      					if ( rtpmapID !== null  ){
      						var match = rtpmapID[2].toLowerCase();
      						if ( ('vp9'.localeCompare(match) == 0 ) ||  ('vp8'.localeCompare(match) == 0 ) || ('h264'.localeCompare(match) == 0 ) ||
      							('red'.localeCompare(match) == 0 ) || ('ulpfec'.localeCompare(match) == 0 ) || ('rtx'.localeCompare(match) == 0 ) )
      						{
      							if (enhanceData.videoBitrate !== undefined) {
      								sdpStrRet+='\r\na=fmtp:'+rtpmapID[1]+' x-google-min-bitrate='+(enhanceData.videoBitrate)+';x-google-max-bitrate='+(enhanceData.videoBitrate);
      							}
      						}

      						if ( ('opus'.localeCompare(match) == 0 ) ||  ('isac'.localeCompare(match) == 0 ) || ('g722'.localeCompare(match) == 0 ) || ('pcmu'.localeCompare(match) == 0 ) ||
      								('pcma'.localeCompare(match) == 0 ) || ('cn'.localeCompare(match) == 0 ))
      						{
      							if (enhanceData.audioBitrate !== undefined){
      								sdpStrRet+='\r\na=fmtp:'+rtpmapID[1]+' x-google-min-bitrate='+(enhanceData.audioBitrate)+';x-google-max-bitrate='+(enhanceData.audioBitrate);
      							}
      						}
      					}
      				}
      			}
      		}
      		sdpStrRet += '\r\n';
      	}
      	console.log("Resuling SDP: "+sdpStrRet);
      	return sdpStrRet;
      },
      deliverCheckLine(profile,type)
      {
      	var outputString = "";
      	for(var line in this.SDPOutput){
      		var lineInUse = this.SDPOutput[line];
      		outputString+=line;
      		if ( lineInUse.includes(profile) ){
      			if ( profile.includes("VP9") || profile.includes("VP8")){
      				var output = "";
      				var outputs = lineInUse.split(/\r\n/);
      				for(var position in outputs){
      					var transport = outputs[position];
      					if (transport.indexOf("transport-cc") !== -1 || transport.indexOf("goog-remb") !== -1 || transport.indexOf("nack") !== -1){
      						continue;
      					}
      					output+=transport;
      					output+="\r\n";
      				}

      				if (type.includes("audio") ){
      					this.audioIndex = line;
      				}

      				if (type.includes("video") ){
      					this.videoIndex = line;
      				}

      				return output;
      			}

            if (type.includes("audio") ){
      				this.audioIndex = line;
      			}

      			if (type.includes("video") ){
      				this.videoIndex = line;
      			}
      			return lineInUse;
      		}
      	}
      	return outputString;
      },
      checkLine(line){
      	if ( line.startsWith("a=rtpmap") || line.startsWith("a=rtcp-fb") || line.startsWith("a=fmtp")){
      		var res = line.split(":");

      		if ( res.length>1 ){
      			var number = res[1].split(" ");
      			if ( !isNaN(number[0]) ){
      				if ( !number[1].startsWith("http") && !number[1].startsWith("ur") ){
      					var currentString = this.SDPOutput[number[0]];
      					if (!currentString){
      						currentString = "";
      					}
      					currentString+=line+"\r\n";
      					this.SDPOutput[number[0]]=currentString;
      					return false;
      				}
      			}
      		}
      	}
      	return true;
      },
      getrtpMapID(line){
      	var findid = new RegExp('a=rtpmap:(\\d+) (\\w+)/(\\d+)');
      	var found = line.match(findid);
      	return (found && found.length >= 3) ? found: null;
      },
      errorHandler(error){
        console.log(error);
      }

    },
    created() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia;
      window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
      window.RTCIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCIceCandidate;
      window.RTCSessionDescription = window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;

      this.wsURL = "wss://5d6df2abd7165.streamlock.net:9443/webrtc-session.json";
      this.streamInfo= {applicationName:"webrtc", streamName:"myStream", sessionId:"[11223]"};
      this.userAgent =  navigator.userAgent;
    },
    mounted(){
      console.log("mounted");
      this.pageReady();
    }
  }
</script>
<style lang="scss">
  .webRTCVideo{
    video{
      width: 100%;
      height: calc(33vw/1.77);
      max-height:100%;
      top: 0;
      right: 0;
    }
    button{
      position: relative;
      bottom:0;
    }
  }

</style>
